import React, { FC, useContext, useMemo, useState } from 'react';

import { Table } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';
import { ClientModal, DepositModal } from 'modals';
import { getLogConfigMap } from 'utils';

import s from './EventLogsTable.module.scss';
import { IEventLogsTableProps } from './interfaces';
import { getLogsTableColumns, getNormalizeLogs } from './utils';

export const EventLogsTable: FC<IEventLogsTableProps> = ({
  eventLogs,
  bottomRadius = true,
}) => {
  const { t } = useContext(LocalizationContext);

  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [selectedClientUUID, setSelectedClientUUID] = useState<string | null>(
    null
  );
  const [isDepositOpen, setIsDepositOpen] = useState(false);

  const events = useMemo(() => {
    if (!eventLogs) return [];

    return getNormalizeLogs(eventLogs);
  }, [eventLogs]);

  const LOG_CONFIGS_MAP = useMemo(() => getLogConfigMap(t), [t]);

  const handleNicknameClick = (clientUUID: string): void => {
    setSelectedClientUUID(clientUUID);
    setIsClientModalOpen(true);
  };

  const handleCloseModal = (): void => {
    setIsClientModalOpen(false);
    setSelectedClientUUID(null);
  };

  return (
    <>
      {isClientModalOpen && selectedClientUUID && !isDepositOpen && (
        <ClientModal
          clientUUID={selectedClientUUID}
          onClose={handleCloseModal}
          setIsDepositOpen={setIsDepositOpen}
        />
      )}
      {isDepositOpen && (
        <DepositModal
          defaultClientUUID={selectedClientUUID}
          onClose={() => {
            setIsDepositOpen(false);
            setIsClientModalOpen(false);
          }}
        />
      )}
      <Table
        data={events}
        columns={getLogsTableColumns(t, LOG_CONFIGS_MAP)}
        getRowClassName={(data) => {
          const { color } = LOG_CONFIGS_MAP[data.type];
          return color !== 'white' ? cn(s.row, s[`row_${color}`]) : s.row;
        }}
        className={cn(s.table, !bottomRadius && s.table__bottom_placeholder)}
        onRowClick={(event, row) => {
          const element = event.target as HTMLDivElement;
          if (element.classList.contains(s.user)) {
            if (
              element.classList.contains('subject') &&
              row.original.subject?.uuid
            ) {
              handleNicknameClick(row.original.subject.uuid);
            } else if (
              element.classList.contains('object') &&
              row.original.object?.uuid
            ) {
              handleNicknameClick(row.original.object.uuid);
            }
          }
        }}
      />
    </>
  );
};
